/**
 * The adapters Sokuji ships, as the /providers table lists them.
 *
 * `runs` is a locale key plus, where the sentence names one, the vendor that
 * actually receives your audio — which is the column's whole point, so it is
 * data rather than prose baked into a translation.
 *
 * `speaks` and `faceToFace` are the two properties a scenario turns on:
 * whether the provider can produce a voice at all, and whether it can serve
 * two people at one microphone. They mirror what the client checks when it
 * closes a scenario off (its `speech` and `faceToFace` capabilities); see
 * scenarios.ts. Face-to-face is Soniox's alone, with your own key or through
 * a Kizuna AI account, and the same provider is the one that labels several
 * speakers on the other side.
 */

export interface ProviderRow {
  /** Product name. A proper noun, so it is not translated. */
  name: string;
  /** Locale key under `providers.run.*`. */
  runs: string;
  /** Substituted into `{vendor}` when the key has one. */
  vendor?: string;
  speaks: 'yes' | 'textOnly' | 'depends';
  /** Whether Both can run with the other side beside you, at one microphone. */
  faceToFace: boolean;
  /** Where the walkthrough lives, under /docs. */
  guide: string;
}

export const PROVIDER_ROWS: readonly ProviderRow[] = [
  { name: 'Local inference', runs: 'local', speaks: 'yes', faceToFace: false, guide: 'tutorials/local-inference-setup' },
  { name: 'OpenAI Realtime', runs: 'direct', vendor: 'OpenAI', speaks: 'yes', faceToFace: false, guide: 'tutorials/openai-setup' },
  { name: 'OpenAI Translate', runs: 'direct', vendor: 'OpenAI', speaks: 'yes', faceToFace: false, guide: 'tutorials/openai-setup' },
  { name: 'OpenAI Live', runs: 'direct', vendor: 'OpenAI', speaks: 'yes', faceToFace: false, guide: 'tutorials/openai-setup' },
  { name: 'Google Gemini', runs: 'direct', vendor: 'Google', speaks: 'yes', faceToFace: false, guide: 'tutorials/gemini-setup' },
  { name: 'Soniox', runs: 'keyOrAccount', vendor: 'Soniox', speaks: 'yes', faceToFace: true, guide: 'tutorials/soniox-setup' },
  { name: 'Palabra AI', runs: 'webrtc', speaks: 'yes', faceToFace: false, guide: 'tutorials/palabraai-setup' },
  { name: 'Doubao AST 2.0', runs: 'direct', vendor: 'Doubao', speaks: 'yes', faceToFace: false, guide: 'tutorials/volcengine-ast2-setup' },
  { name: 'Qwen LiveTranslate', runs: 'keyOrAccount', vendor: 'Alibaba Cloud', speaks: 'yes', faceToFace: false, guide: 'tutorials/qwen-setup' },
];
